import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import AdminRoute from '../components/feature/AdminRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const Login = lazy(() => import('../pages/auth/login/page'));
const ResetPassword = lazy(() => import('../pages/auth/reset-password/page'));
const VerificarEmail = lazy(() => import('../pages/auth/verificar-email/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const Privacidade = lazy(() => import('../pages/privacidade/page'));
const Termos = lazy(() => import('../pages/termos/page'));
const Perfil = lazy(() => import('../pages/perfil/page'));
const ComunidadePage = lazy(() => import('../pages/comunidade/page'));
const MembroPerfil = lazy(() => import('../pages/membro/page'));
const Sobre = lazy(() => import('../pages/sobre/page'));
const DashboardBackupsPage = lazy(() => import('../pages/dashboard/backups/page'));
const DashboardTemplatesPage = lazy(() => import('../pages/dashboard/templates/page'));
const DashboardNotificacoesPage = lazy(() => import('../pages/dashboard/notificacoes/page'));
const DashboardHistoricoEmailsPage = lazy(() => import('../pages/dashboard/historico-emails/page'));
const DashboardComprasPage = lazy(() => import('../pages/dashboard/compras/page'));
const GratidaoPage = lazy(() => import('../pages/gratidao/page'));
const GaleriaPage = lazy(() => import('../pages/galeria/page'));
const DepoimentosPage = lazy(() => import('../pages/depoimentos/page'));
const QuizPage = lazy(() => import('../pages/quiz/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog/[slug]/page'));
const PlanosPage = lazy(() => import('../pages/planos/page'));
const PagamentoSucessoPage = lazy(() => import('../pages/planos/sucesso/page'));
const ExercicioDetalhes = lazy(() => import('../pages/exercicio/[id]/page'));
const ExperienciaDetalhes = lazy(() => import('../pages/experiencia/[id]/page'));
const WorksheetEncantationsPage = lazy(() => import('../pages/worksheet-encantations/page'));
const WorksheetSwishPage = lazy(() => import('../pages/worksheet-swish/page'));
const WorksheetLinhaTempoPage = lazy(() => import('../pages/worksheet-linha-tempo/page'));
const WorksheetRessignificacaoPage = lazy(() => import('../pages/worksheet-ressignificacao/page'));
const WorksheetSubmodalidadesPage = lazy(() => import('../pages/worksheet-submodalidades/page'));
const TecnicaSwishGratis = lazy(() => import('../pages/exercicio-gratis/tecnica-swish-pnl/page'));
const EncantationsGratis = lazy(() => import('../pages/exercicio-gratis/encantations-tony-robbins/page'));
const ConquistasPage = lazy(() => import('../pages/conquistas/page'));
const AcessoGratuitoAdmin = lazy(() => import('../pages/admin/acesso-gratuito/page'));
const AdminVitoriasPage = lazy(() => import('../pages/admin/vitorias/page'));
const AdminPainelPage = lazy(() => import('../pages/admin/painel/page'));
const AdminAnalyticsPage = lazy(() => import('../pages/admin/analytics/page'));
const AdminUsuariosPage = lazy(() => import('../pages/admin/usuarios/page'));
const LinksInstagramPage = lazy(() => import('../pages/admin/links-instagram/page'));
const CalendarioEditorialPage = lazy(() => import('../pages/admin/calendario-editorial/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const BoasVindasGratuito = lazy(() => import('../pages/boas-vindas-gratuito/page'));
const ResultadosPage = lazy(() => import('../pages/resultados/page'));
const InfluencerPage = lazy(() => import('../pages/influencer/page'));
const CapturaPage = lazy(() => import('../pages/captura/page'));
const ProgramaDiarioPage = lazy(() => import('../pages/programa-diario/page'));
const DiarioPage = lazy(() => import('../pages/diario/page'));
const VitoriasPage = lazy(() => import('../pages/vitorias/page'));
const TesteEmailPage = lazy(() => import('../pages/admin/teste-email/page'));
const TesteEnvioCartasPage = lazy(() => import('../pages/admin/teste-envio-cartas/page'));
const ValidacaoCartasPage = lazy(() => import('../pages/admin/validacao-cartas/page'));
const ModelagemExcelenciaGratis = lazy(() => import('../pages/exercicio-gratis/modelagem-excelencia-pnl/page'));
const AmorIdealGratis = lazy(() => import('../pages/exercicio-gratis/amor-ideal/page'));
const SaudeBemEstarGratis = lazy(() => import('../pages/exercicio-gratis/saude-bem-estar/page'));
const ProsperidadeCarreiraGratis = lazy(() => import('../pages/exercicio-gratis/prosperidade-carreira/page'));
const PropositoVidaGratis = lazy(() => import('../pages/exercicio-gratis/proposito-vida/page'));
const IdentidadeAltaPerformanceGratis = lazy(() => import('../pages/exercicio-gratis/identidade-alta-performance/page'));
const OnboardingPage = lazy(() => import('../pages/onboarding/page'));
const AudiosExerciciosAdmin = lazy(() => import('../pages/admin/audios-exercicios/page'));
const PreviewAudiosAdmin = lazy(() => import('../pages/admin/audios-exercicios/preview/page'));
const TemplatesSupabasePage = lazy(() => import('../pages/admin/templates-supabase/page'));
const AdminEmailsPage = lazy(() => import('../pages/admin/emails/page'));
const PreviewSitePage = lazy(() => import('../pages/admin/preview-site/page'));
const PreviewDashboardPage = lazy(() => import('../pages/admin/preview-dashboard/page'));
const ChecklistTestesPage = lazy(() => import('../pages/admin/checklist-testes/page'));
const ConfigurarStripePage = lazy(() => import('../pages/admin/configurar-stripe/page'));
const EscreverCartaPage = lazy(() => import('../pages/escrever-carta/page'));
const MapaDoSitePage = lazy(() => import('../pages/mapa-do-site/page'));
const ExerciciosGratisIndexPage = lazy(() => import('../pages/exercicios-gratis/page'));
const ObrigadoExercicioPage = lazy(() => import('../pages/obrigado-exercicio/page'));
const LandingPageExercicios = lazy(() => import('../pages/landingpage-exercicios/page'));
const DiagnosticoPage = lazy(() => import('../pages/diagnostico/page'));
const LinksPage = lazy(() => import('../pages/links/page'));
const ObrigadoLinksPage = lazy(() => import('../pages/obrigado-links/page'));
const TestesPage = lazy(() => import('../pages/testes/page'));
const InstagramLandingPage = lazy(() => import('../pages/instagram/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/onboarding',
    element: <OnboardingPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/dashboard/backups',
    element: <DashboardBackupsPage />,
  },
  {
    path: '/dashboard/templates',
    element: <DashboardTemplatesPage />,
  },
  {
    path: '/dashboard/notificacoes',
    element: <DashboardNotificacoesPage />,
  },
  {
    path: '/dashboard/historico-emails',
    element: <DashboardHistoricoEmailsPage />,
  },
  {
    path: '/dashboard/compras',
    element: <DashboardComprasPage />,
  },
  {
    path: '/auth/login',
    element: <Login />,
  },
  {
    path: '/auth/verificar-email',
    element: <VerificarEmail />,
  },
  {
    path: '/auth/bem-vindo',
    lazy: async () => {
      const { default: BemVindo } = await import('../pages/auth/bem-vindo/page');
      return { Component: BemVindo };
    },
  },
  {
    path: '/auth/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/auth/carregando',
    lazy: async () => {
      const { default: CarregandoPage } = await import('../pages/auth/carregando/page');
      return { Component: CarregandoPage };
    },
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/privacidade',
    element: <Privacidade />,
  },
  {
    path: '/termos',
    element: <Termos />,
  },
  {
    path: '/perfil',
    element: <Perfil />,
  },
  {
    path: '/comunidade',
    element: <ComunidadePage />,
  },
  {
    path: '/membro/:id',
    element: <MembroPerfil />,
  },
  {
    path: '/sobre',
    element: <Sobre />,
  },
  {
    path: '/imprensa',
    lazy: async () => {
      const { default: ImprensaPage } = await import('../pages/imprensa/page');
      return { Component: ImprensaPage };
    }
  },
  {
    path: '/gratidao',
    element: <GratidaoPage />,
  },
  {
    path: '/galeria',
    element: <GaleriaPage />,
  },
  {
    path: '/depoimentos',
    element: <DepoimentosPage />,
  },
  {
    path: '/quiz',
    element: <QuizPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogArticlePage />,
  },
  {
    path: '/planos',
    element: <PlanosPage />,
  },
  {
    path: '/planos/sucesso',
    element: <PagamentoSucessoPage />,
  },
  {
    path: '/exercicio/:id',
    element: <ExercicioDetalhes />,
  },
  {
    path: '/experiencia/:id',
    element: <ExperienciaDetalhes />,
  },
  {
    path: '/worksheet-encantations',
    element: <WorksheetEncantationsPage />,
  },
  {
    path: '/worksheet-swish',
    element: <WorksheetSwishPage />,
  },
  {
    path: '/worksheet-ressignificacao',
    element: <WorksheetRessignificacaoPage />,
  },
  {
    path: '/worksheet-linha-tempo',
    element: <WorksheetLinhaTempoPage />,
  },
  {
    path: '/worksheet-submodalidades',
    element: <WorksheetSubmodalidadesPage />,
  },
  {
    path: '/exercicio-gratis/tecnica-swish-pnl',
    element: <TecnicaSwishGratis />,
  },
  {
    path: '/exercicio-gratis/encantations-tony-robbins',
    element: <EncantationsGratis />,
  },
  {
    path: '/exercicio-gratis/ressignificacao-reframing-pnl',
    lazy: async () => {
      const { default: Component } = await import('../pages/exercicio-gratis/ressignificacao-reframing-pnl/page');
      return { Component };
    }
  },
  {
    path: '/exercicio-gratis/linha-tempo-pnl',
    lazy: async () => {
      const { default: Component } = await import('../pages/exercicio-gratis/linha-tempo-pnl/page');
      return { Component };
    }
  },
  {
    path: '/exercicio-gratis/submodalidades-pnl',
    lazy: async () => {
      const Component = (await import('../pages/exercicio-gratis/submodalidades-pnl/page')).default;
      return { Component };
    }
  },
  {
    path: '/exercicio-gratis/ancoragem-emocional',
    lazy: async () => {
      const Component = (await import('../pages/exercicio-gratis/ancoragem-emocional/page')).default;
      return { Component };
    }
  },
  {
    path: '/exercicio-gratis/modelagem-excelencia-pnl',
    element: <ModelagemExcelenciaGratis />,
  },
  {
    path: '/exercicio-gratis/amor-ideal',
    element: <AmorIdealGratis />,
  },
  {
    path: '/exercicio-gratis/saude-bem-estar',
    element: <SaudeBemEstarGratis />,
  },
  {
    path: '/exercicio-gratis/prosperidade-carreira',
    element: <ProsperidadeCarreiraGratis />,
  },
  {
    path: '/exercicio-gratis/proposito-vida',
    element: <PropositoVidaGratis />,
  },
  {
    path: '/exercicio-gratis/identidade-alta-performance',
    element: <IdentidadeAltaPerformanceGratis />,
  },
  {
    path: '/exercicios-gratis',
    element: <ExerciciosGratisIndexPage />,
  },
  {
    path: '/obrigado-exercicio',
    element: <ObrigadoExercicioPage />,
  },
  {
    path: '/landingpage-exercicios',
    element: <LandingPageExercicios />,
  },
  {
    path: '/diagnostico',
    element: <DiagnosticoPage />,
  },
  {
    path: '/conquistas',
    element: <ConquistasPage />,
  },
  {
    path: '/admin/acesso-gratuito',
    element: <AdminRoute><AcessoGratuitoAdmin /></AdminRoute>,
  },
  {
    path: '/admin/vitorias',
    element: <AdminRoute><AdminVitoriasPage /></AdminRoute>,
  },
  {
    path: '/admin/painel',
    element: <AdminRoute><AdminPainelPage /></AdminRoute>,
  },
  {
    path: '/admin/analytics',
    element: <AdminRoute><AdminAnalyticsPage /></AdminRoute>,
  },
  {
    path: '/admin/usuarios',
    element: <AdminRoute><AdminUsuariosPage /></AdminRoute>,
  },
  {
    path: '/admin/links-instagram',
    element: <AdminRoute><LinksInstagramPage /></AdminRoute>,
  },
  {
    path: '/admin/calendario-editorial',
    element: <AdminRoute><CalendarioEditorialPage /></AdminRoute>,
  },
  {
    path: '/admin/configurar-resend',
    lazy: async () => {
      const { default: Component } = await import('../pages/admin/configurar-resend/page');
      return { 
        Component: () => <AdminRoute><Component /></AdminRoute>
      };
    },
  },
  {
    path: '/admin/teste-email',
    element: <AdminRoute><TesteEmailPage /></AdminRoute>
  },
  {
    path: '/admin/teste-envio-cartas',
    element: <AdminRoute><TesteEnvioCartasPage /></AdminRoute>
  },
  {
    path: '/admin/validacao-cartas',
    element: <AdminRoute><ValidacaoCartasPage /></AdminRoute>
  },
  {
    path: '/admin/audios-exercicios',
    element: <AdminRoute><AudiosExerciciosAdmin /></AdminRoute>,
  },
  {
    path: '/admin/audios-exercicios/preview',
    element: <AdminRoute><PreviewAudiosAdmin /></AdminRoute>,
  },
  {
    path: '/admin/templates-supabase',
    element: <AdminRoute><TemplatesSupabasePage /></AdminRoute>,
  },
  {
    path: '/admin/emails',
    element: <AdminRoute><AdminEmailsPage /></AdminRoute>,
  },
  {
    path: '/admin/preview-site',
    element: <AdminRoute><PreviewSitePage /></AdminRoute>,
  },
  {
    path: '/admin/preview-dashboard',
    element: <AdminRoute><PreviewDashboardPage /></AdminRoute>,
  },
  {
    path: '/admin/checklist-testes',
    element: <AdminRoute><ChecklistTestesPage /></AdminRoute>,
  },
  {
    path: '/admin/configurar-stripe',
    element: <AdminRoute><ConfigurarStripePage /></AdminRoute>,
  },
  {
    path: '/boas-vindas-gratuito',
    element: <BoasVindasGratuito />
  },
  {
    path: '/resultados',
    element: <ResultadosPage />
  },
  {
    path: '/influencer',
    element: <InfluencerPage />,
  },
  {
    path: '/influencer/materiais',
    lazy: async () => {
      const { default: MateriaisInfluencer } = await import('../pages/influencer/materiais/page');
      return { Component: MateriaisInfluencer };
    },
  },
  {
    path: '/captura',
    element: <CapturaPage />
  },
  {
    path: '/programa-diario',
    element: <ProgramaDiarioPage />,
  },
  {
    path: '/diario',
    element: <DiarioPage />,
  },
  {
    path: '/vitorias',
    element: <VitoriasPage />,
  },
  {
    path: '/escrever-carta',
    element: <EscreverCartaPage />,
  },
  {
    path: '/mapa-do-site',
    element: <MapaDoSitePage />,
  },
  {
    path: '/links',
    element: <LinksPage />,
  },
  {
    path: '/obrigado-links',
    element: <ObrigadoLinksPage />,
  },
  {
    path: '/testes',
    element: <TestesPage />,
  },
  {
    path: '/instagram',
    element: <InstagramLandingPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;